<template>
<v-form >
  <v-card :flat='flat' :dark='dark' >
    <v-card-title class='subtitle-1 overline' >
      {{ $t('title') }}
    </v-card-title>
    <v-card-actions >
      <v-btn @click='showDeleteDialog=true' class='error' >
        {{ $t('buttons.delete') }}
      </v-btn>
      <v-btn
        @click='showRescheduleDialog=true'
        class='primary' >{{ $t('buttons.reschedule') }}</v-btn>
    </v-card-actions>
  </v-card>

  <v-dialog v-model='showDeleteDialog' >
    <delete-recurring-appointment-form
      @close='showDeleteDialog=false'
      v-model='appointment' >
    </delete-recurring-appointment-form>
  </v-dialog>
  <v-dialog v-model='showRescheduleDialog' >
    <reschedule-recurring-appointment-form
      @close='showRescheduleDialog=false'
      v-model='appointment' >
    </reschedule-recurring-appointment-form>
  </v-dialog>
</v-form>
</template>
<script>
import DeleteRecurringAppointmentForm from '@/components/forms/DeleteRecurringAppointmentForm'
import RescheduleRecurringAppointmentForm from '@/components/forms/RescheduleRecurringAppointmentForm'

export default {
  name: 'RecurringAppointmentForm',
  components: {
    DeleteRecurringAppointmentForm,
    RescheduleRecurringAppointmentForm
  },
  props: {
    value: { type: Object, required: true },
    flat: { type: Boolean, default: true },
    dark: { type: Boolean, default: true }
  },
  data () {
    return {
      appointment: {},
      futureOnly: true,
      showDeleteDialog: false,
      showRescheduleDialog: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.appointment = this.value }
      }
    }
  },
  methods: {
    performDelete () {
      // performAction("practitioner", this.appointment, "delete_recurring", params)
    }
  },
  computed: {
    deleteHintText () {
      if (this.futureOnly) {
        return 'Will only delete this appointment and the appointments that start after this appointment in the series'
      } else {
        return 'Will delete all appointments in the series'
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'This appointment is part of a recurring sequence of appointments',
        buttons: {
          delete: 'Delete series ..',
          reschedule: 'Reschedule series ..'
        }
      },
      es: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// RecurringAppointmentForm.vue?6eda466e